import { Row, Col } from "antd";
import moment from 'moment';
import { currencyFormat } from "../../../../../../helpers/utilities";

export const ChallanFormat = (props) => {
    const { details, clsx, classes, selected } = props;

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    return (
        <div className={clsx(classes.printFullPage, classes.formatSecond, 'pagebreak')} data-invoiceid={details?.serialNo}>
            <div className={classes.downloadbars}>
                <div className={classes.downloadtopbar}>
                    <Row align={"middle"}>
                        <Col span={12} className={clsx(classes.downloadtopbarHeading)}>
                            <span>Original</span></Col>
                        <Col span={12} style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadtopbarHeading, classes.textAlignRight)}>
                            Delivery Challan
                        </Col>
                    </Row>
                </div>
            </div>
            <div className={clsx(classes.ddfsection, classes.margin15t)}>
                <Row>
                    <Col span={12}>
                        <h1>{details?.business?.name || '---'}</h1>
                        <p>{address(details?.business)}</p>
                        <p>{address1(details?.business)}</p>
                        <Row className={clsx(classes.margin30t)}>
                            {
                                details?.selfBill?.includeGst && <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <p>GSTIN</p>
                                        </Col>
                                        <Col span={18}>
                                            <p>{details?.business?.gstNumber || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                            <Col span={12}>
                                <Row>
                                    <Col span={6}>
                                        <p>Ph No.</p>
                                    </Col>
                                    <Col span={18}>
                                        <p>{details?.business?.mobile || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row>
                                    <Col span={3}>
                                        <p>Email</p>
                                    </Col>
                                    <Col span={21}>
                                        <p className={clsx(classes.emailText)}>{details?.business?.email || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12} className={classes.textAlignRight}>
                        <h1 className={classes.textAlignRight}>Order Number</h1>
                        <p className={classes.textAlignRight}>{details?.serialNo || '---'}</p>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.ddssection, classes.margin10t)}>
                <Row className={clsx(classes.alginitemNormal)}>
                    <Col span={12} className={clsx(classes.ddssectionpadding)} style={{ border: "none" }}>
                        <h6>Consignee</h6>
                        <p className={clsx(classes.margin25t)}>{details?.name || '---'}</p>
                        <p>{address(details)}</p>
                        <p>{address1(details)}</p>
                    </Col>
                    <Col span={12} className={clsx(classes.ddssectionpadding, classes.textAlignRight)} style={{ border: "none" }}>
                        <h6>Reference Number</h6>
                        <p className={clsx(classes.margin25t, classes.bold)}>{details?.selfBill?.serialNo || '---'}</p>
                    </Col>
                </Row>
                <Row>
                    <Col span={12} className={clsx(classes.ddssectionpadding)} style={{ border: "none" }}>
                        <Row>
                            {
                                details?.includeGst &&
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>GSTIN</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{details?.customer?.gstin || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                            <Col span={12}>
                                <Row>
                                    <Col span={6}>
                                        <h6>Ph No.</h6>
                                    </Col>
                                    <Col span={18}>
                                        <p>{details?.phone || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row>
                                    <Col span={3}>
                                        <h6>Email</h6>
                                    </Col>
                                    <Col span={21}>
                                        <p>{details?.email || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12} className={clsx(classes.ddssectionpadding, classes.textAlignRight)} style={{ border: "none" }}>
                        <h6>Date</h6>
                        <p className={clsx(classes.margin25t)}>{details?.deliveryDate ? moment(details.deliveryDate).format('DD MMM YYYY') : '---'}</p>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.ddssection)} style={{ borderTop: "none" }}>
                <div className={clsx(classes.PlaceofSupply, classes.customDDssection)}>Place of Supply
                    <span className={classes.PlaceofSupplyText}>{details?.state?.name}</span></div>
                <div className={clsx(classes.thirdSection, classes.margin15t)}>
                    <Row className={clsx(classes.bill, classes.margin20t, classes.viewPrint)}>
                        <Col span={2}><h6>L. No.</h6></Col>
                        <Col span={12}><h6>Description</h6></Col>
                        <Col span={4}><h6>HSN Code</h6></Col>
                        <Col span={3} ><h6>Quantity | Unit</h6></Col>
                        <Col span={3} className={clsx(classes.textAlignRight)}><h6>Unit Price</h6></Col>
                    </Row>
                    {
                        details && details?.salesOrderLineItems && details?.salesOrderLineItems?.filter((el) => selected.find((e) => e === el.id))?.length > 0 ? details?.salesOrderLineItems?.filter((el) => selected.find((e) => e === el.id))?.map((data, i) => (
                            <Row className={clsx(classes.bill, classes.viewPrint)} key={i}>
                                <Col span={2}><p>{i + 1}</p></Col>
                                <Col span={12}><p>{data.description ? data.description : '---'}</p></Col>
                                <Col span={4}><p>{data?.hsn?.hsnCode || '---'}</p></Col>
                                <Col span={3}><p className={clsx(classes.disInline)}>{data.deliver_now}</p> <p className={clsx(classes.disInline, classes.textAlignRight)}>{data?.unit?.name || '---'}</p></Col>
                                <Col span={3} className={clsx(classes.textAlignRight)}><p> {`${data.pricePerUnit ? currencyFormat(data.pricePerUnit) : '---'}`}</p></Col>

                            </Row>
                        )) : <Row className={clsx(classes.bill, classes.viewPrint)}>
                            <Col span={24} className={classes.textAlignCenter}><p>No lines found</p></Col></Row>
                    }
                </div>
            </div>
            <div className={clsx(classes.ddssection)} style={{ borderTop: "none" }}>
                <div className={clsx(classes.ddssectionpadding, classes.padding55t)} style={{ border: "none" }}>
                    Authorized Signatory
                </div>
            </div>
        </div>
    )
}